module.exports = __webpack_public_path__ + "static/img/message_empty@2x.b561f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/message_empty@2x.png
// module id = 66lX
// module chunks = 1